export default __webpack_public_path__ + "locales/nl/ChangeUserTypeDialog.json?hash=147285fbe871a124b77c54c941fb1054";